import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const HelperText = styled.p`
  font-size: 14px;
  text-align: center;
  margin: 0 auto 32px;
  color: var(--font-primary, #152946);

  @media (min-width: ${DEVICE.mobileXL}) {
    font-size: 16px;
  }
`;
